<template>
    <EmployeeViewRequest></EmployeeViewRequest>
</template>
<script>
    import EmployeeViewRequest from '@/components/EmployeeViewRequest.vue'
    export default {
        name: 'employee-view-request',
        components: {
            EmployeeViewRequest
        }
    }
</script>